import { TranslateService } from 'ng2-translate';
/**
 * Created by Owner on 2016/8/13.
 */
import { AlertController, NavParams } from 'ionic-angular';
import { Component, Input, Output, EventEmitter, ElementRef, AfterViewInit } from '@angular/core';
import { LotteryMath } from "../lotteryMath";
import { ToastController } from "ionic-angular";
import { AppDialog } from "../../appDialog";
import { LotteryPage } from "../../../pages/lottery/lottery";
import { mmcFace } from '../../../+lotteryFace/mmc';
import { LotteryService } from '../../../services/lottery.services';

const HASH_BASE_RATIO_START_LOXIEN = 'lx';
const HASH_BASE_RATIO_START_LOTRUOT = 'lt';

@Component({
    selector: 'lottery-select-de-topbot',
    templateUrl: 'selectTypeDeTopBot.html'
})
export class SelectTypeDeTopBotComponent implements AfterViewInit {
    @Output() onTotal: EventEmitter<any> = new EventEmitter<any>();
    @Output() onActiveLottery2: EventEmitter<any> = new EventEmitter<any>();
    typeGame;
    
    descGuide: string;
    _selectAreaOption: any;
    arrNumItemFast: any;
    arrNumItemDeTopBot: any;
    numArrVal: number;
    numRender: any;
    arrNumSelected = [];
    countNumSelected: number = 0;
    test: number = 0;
    valSequence: string;
    pageDome: HTMLElement;
    disableFlagBtn: boolean = false;
    defaultPosition: any = [];
    initParams:any;
    listNumberSelected = [];
    lotteryFaces = mmcFace;
    ActiveLottery:any;
    typeChonSo = 'chonsonhanh';
    @Input() methodID: any;
    _activeLottery: any;
    @Input()
    set activeLottery(activeLotteryInit: any) {
        if (!activeLotteryInit) {
            return;
        }
        this._activeLottery = activeLotteryInit;
    }

    get activeLottery() {
        return this._activeLottery;
    }
    @Output() onInitAfter: EventEmitter<any> = new EventEmitter<any>();
    @Input()
    set selectAreaOption(selectAreaOption: any) {

        
        this.descGuide = selectAreaOption.objCustom.methoddesc;
        this._selectAreaOption = selectAreaOption;
        this.arrNumItemFast = this.selectAreaOption.layoutfastslect;
        //update new
        this.arrNumItemDeTopBot = this.selectAreaOption.LayoutTopBot;
        
        //xử lý tỉ lệ.
        
        if( this.arrNumItemDeTopBot == undefined) return; 
        this.arrNumItemDeTopBot.forEach(category => {
            // category.no.forEach(item => {
            //     const found = this.selectAreaOption.objCustom.userPrizeCurrent.find(entry => entry.methodid === String(item.methodid));
            //     if (found) {
            //         console.log('found',found);
            //         item = {
            //             ...found,
            //             rate : parseFloat(found.dyprize[0].prize[0].prizeFe)
            //         }
            //         console.log('item',item);
                    
            //     }
            // });
            category.no = category.no.map(item => {
                const found = this.selectAreaOption.objCustom.userPrizeCurrent.find(entry => entry.methodid === String(item.methodid));
                return found ? { ...item, 
                    ...found,
                     rate: parseFloat(found.dyprize[0].prize[0].prizeFe), 
                     codePlay: found.playcode,
                    //  title:found.methodname,
                 } : item;
            }); 
            console.log('category.no',category.no);
            

        });
        
        // console.log(this.arrNumItemDeTopBot);

        // console.log(' this.arrNumItemDeTopBot', this.arrNumItemDeTopBot);
        
        this.typeGame = this._selectAreaOption.mname;
        this.resetFirstNumFast();
    }
    get selectAreaOption() {
        return this._selectAreaOption;
    }

    constructor(private alertCtrl: AlertController,
        private lotteryService: LotteryService,
        public navParams: NavParams,
         private el: ElementRef,
         private translate: TranslateService) {
        this.pageDome = el.nativeElement;
        

        
    }
   
    initView() {
        this.resetFirstNumFast();
        this.resetSelections();
    }

    resetFirstNumFast() {
        this.numArrVal = 0;
        this.countNumSelected = 0;

        this.arrNumSelected = [];
        this.listNumberSelected = [];
        this.disableFlagBtn = false;
        this.renderNumFast();
    }

    ionViewWillEnter() {
        this.listNumberSelected = [];
    }

    ngAfterViewInit() {

    }

    renderNumFast() {
       
        let getSequence = this.arrNumItemFast[this.numArrVal];
        let arrStrNumRender = [];
        if (getSequence) {
            let startNum = getSequence.start;
            let endNum = getSequence.end;

            if (this.arrNumSelected[startNum + '-' + endNum] === undefined) {
                this.arrNumSelected[startNum + '-' + endNum] = [];
            }

            this.valSequence = getSequence;

            for (let i = Number(startNum); i <= Number(endNum); i++) {
                let numStr: any = i;
                let objTemp = {
                    num: numStr,
                    status: 0
                };
                if (this.disableFlagBtn) {
                    objTemp.status = 2;
                }
                if (endNum.length === 3 && i < 10) {
                    numStr = '00' + i;
                } else if ((endNum.length === 2 && i < 10) || (endNum.length === 3 && i < 100)) {
                    numStr = '0' + i;
                }
                objTemp.num = numStr.toString();

                for (let item in this.arrNumSelected) {
                    if (item) {
                        if (this.arrNumSelected[item].length > 0) {
                            if (this.arrNumSelected[item].indexOf(objTemp.num) > -1) {
                                objTemp.status = 1;
                            }
                        }
                    }
                }
                arrStrNumRender.push(objTemp);
            }
        }
        this.numRender = arrStrNumRender;
    }

    selectedNumItem(el: any, elNumFast: string) {
      
        let getSequence = this.arrNumItemFast[this.numArrVal];
        let startNum = getSequence.start;
        let endNum = getSequence.end;
        let checkActive = el.currentTarget.classList.contains('active');
        let checkDisable = el.currentTarget.classList.contains('num__disable');
        let countNum = 0;

        if (checkDisable) return;

        if (checkActive) {
            el.currentTarget.classList.remove('active');
            let idxNum = this.arrNumSelected[startNum + '-' + endNum].indexOf(elNumFast);
            this.arrNumSelected[startNum + '-' + endNum].splice(idxNum, 1);
            // update new
            this.listNumberSelected = this.listNumberSelected.filter(item => item != elNumFast).filter(item => !item.includes('&'));
        } else {
            el.currentTarget.classList.add('active');
            this.arrNumSelected[startNum + '-' + endNum].push(elNumFast);
        }
        for (let item in this.arrNumSelected) {
            countNum += this.arrNumSelected[item].length;
        }
       
        this.countNum();
    }


    renderTypeGame() {
       
        let getSequence = this.arrNumItemFast[this.numArrVal];
        let arrStrNumRender = [];
        if (getSequence) {
            let startNum = getSequence.start;
            let endNum = getSequence.end;

            if (this.arrNumSelected[startNum + '-' + endNum] === undefined) {
                this.arrNumSelected[startNum + '-' + endNum] = [];
            }

            this.valSequence = getSequence;

            for (let i = Number(startNum); i <= Number(endNum); i++) {
                let numStr: any = i;
                let objTemp = {
                    num: numStr,
                    status: 0
                };
                if (this.disableFlagBtn) {
                    objTemp.status = 2;
                }
                if (endNum.length === 3 && i < 10) {
                    numStr = '00' + i;
                } else if ((endNum.length === 2 && i < 10) || (endNum.length === 3 && i < 100)) {
                    numStr = '0' + i;
                }
                objTemp.num = numStr.toString();

                for (let item in this.arrNumSelected) {
                    if (item) {
                        if (this.arrNumSelected[item].length > 0) {
                            if (this.arrNumSelected[item].indexOf(objTemp.num) > -1) {
                                objTemp.status = 1;
                            }
                        }
                    }
                }
                arrStrNumRender.push(objTemp);
            }
        }
        this.numRender = arrStrNumRender;
    }

    InitGame(type){
       
    }

    selectedTypeGame(el: any, type: any) {
        this.listNumberSelected = [];
        document.querySelectorAll('button').forEach(button =>  button.classList.remove('active'));
        let checkActive = el.currentTarget.classList.contains('active');
        el.currentTarget.classList.add('active');
            this.arrNumItemDeTopBot.forEach(category => {
                category.no.forEach(item => {
                    item.status = (item === type) ? 1 : 2;
                });
            });
            this.listNumberSelected = [type];

        // if (checkActive) {
        //     el.currentTarget.classList.remove('active');
        //     this.arrNumItemDeTopBot.forEach(category => {
        //         category.no.forEach(item => {
        //             item.status = 0;
        //         });
        //     });
           
        // } else {
        //     el.currentTarget.classList.add('active');
        //     this.arrNumItemDeTopBot.forEach(category => {
        //         category.no.forEach(item => {
        //             item.status = (item === type) ? 1 : 2;
        //         });
        //     });
        //     this.listNumberSelected = [type];
        // }
        
        this.onActiveLottery2.emit({
            activeGame: type,
        });
        // console.log('this.arrNumItemDeTopBot',this.arrNumItemDeTopBot);
        
        // this.checkLxNum(countNum);
        // this.setClassDisable();
        this.countNum();
        //LotteryPage.clickPlay();
        // this.updateCountForRanges();
    }

    countNum() {
        let mname = this.selectAreaOption["mname"];
        let arrTempMer = this.listNumberSelected;
        
        arrTempMer =  arrTempMer.filter((value, index, self) => self.indexOf(value) === index);
        
        this.countNumSelected = arrTempMer.length;
        this.onTotal.emit({
            total: arrTempMer.length,
            selectNo: arrTempMer,
            defaultPosition: this.defaultPosition,
            type: 'f-digital'
        });
    }

    showSequenceNum(e: any) {
        // this.updateCountForRanges();

        let html = '<ul class="list__sequence">';
        for (let i = 0, len = this.arrNumItemFast.length; i < len; i++) {
            let classActive = '';
            let startNum = this.arrNumItemFast[i].start;
            let endNum = this.arrNumItemFast[i].end;
            let strCountNumShow = this.arrNumItemFast[i].count || ''; // Hiển thị count nếu có

            if (this.numArrVal === i) {
                classActive = 'active';
            }

            html += `<li class="sequenceItem clearfix ${classActive}">
                     <span class="valSelectedSeque">${startNum} - ${endNum}</span>
                     <div class="fr">
                       <span class="countSubNum">${strCountNumShow}</span>
                       <span class="checkedSequence"></span>
                     </div>
                   </li>`;
        }
        html += '</ul>';

        let alertSequence = this.alertCtrl.create({
            title: this.translate.instant('SELECT_NUMBER_SEQUENCE'),
            message: html,
            cssClass: 'alert__sequence',
            enableBackdropDismiss: false,
            buttons: [
                {
                    text: 'OK',
                    handler: () => {
                        this.renderNumFast();
                        setTimeout(() => {
                            // this.selectMultipleNumbers();
                        }, 300)
                    }
                }
            ]
        });

        alertSequence.present().then(() => {
            let arrEl = document.querySelectorAll('.sequenceItem');
            for (let i = 0, len = arrEl.length; i < len; i++) {
                if (arrEl[i].querySelector('.countSubNum').textContent !== '') {
                    arrEl[i].querySelector('.countSubNum')["style"].display = 'inline-block';
                }
                arrEl[i].addEventListener('click', e => {
                    [].forEach.call(arrEl, function (el) {
                        el.classList.remove("active");
                    });
                    e.currentTarget["className"] += ' active';
                    this.numArrVal = i;
                });
            }
        }).catch(e => {
            console.log(e);
        });
    }

    handleNumbersGenerated(number) {
        this.listNumberSelected = number.split(/;|&/);
        // this.listNumberSelected = number.split(/;/);
        // this.selectMultipleNumbers();

    }
    resetSelections() {

        // Clear active classes on all buttons  
        document.querySelectorAll('button.active').forEach((button) => {
            button.classList.remove('active');
        });

        document.querySelectorAll('button').forEach(button =>  button.classList.remove('active'));
        

        
        this.arrNumItemDeTopBot.forEach(category => {
            category.no.forEach(item => {
                item.status = 0;
            });
        });
    }


}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/selectTypeDeTopBot/selectTypeDeTopBot.ts